
import React from 'react';
import { Loader2, Users } from 'lucide-react';

interface AudienceSizeIndicatorProps {
  audienceSize: number;
  audienceLoading: boolean;
}

const AudienceSizeIndicator: React.FC<AudienceSizeIndicatorProps> = ({
  audienceSize,
  audienceLoading
}) => {
  return (
    <div className="bg-muted p-4 rounded-md mt-4">
      <div className="flex justify-between items-center">
        <div>
          <p className="text-sm font-medium">Estimated Audience Size</p>
          <p className="text-muted-foreground text-sm">
            Recipients who will receive this campaign (opted-in customers synced to SMS platform)
          </p>
        </div>
        {audienceLoading ? (
          <div className="text-2xl font-bold flex items-center">
            <Loader2 className="h-5 w-4 mr-2 animate-spin" />
            Loading...
          </div>
        ) : (
          <div className="text-2xl font-bold">
            <Users className="h-5 w-5 inline-block mr-2" />
            {audienceSize}
          </div>
        )}
      </div>
    </div>
  );
};

export default AudienceSizeIndicator;
